import qr from "qrcode";

export default async (dataString: string): Promise<string> => {
    const qrCode = await qr.toDataURL(dataString, {
        width: 288,
    });
    return qrCode;
};
